import { useAiFeatureSettings } from "src/hooks/use-ai-feature-settings";
import { useAgentsEnabledFlag } from "src/pages/agents/hooks/use-agents-enabled-flag";

/** The org-level conditions every resource agent sidebar requires. */
export function useAgentsSidebarAvailable(): boolean {
  const { agents: agentsFeatureEnabled } = useAiFeatureSettings();
  const agentsTierEnabled = useAgentsEnabledFlag();
  return Boolean(agentsFeatureEnabled && agentsTierEnabled);
}
